import styled from 'styled-components'

export const ActiveTrackNameWrapper = styled.div`
  display: flex;
  gap: 3px;
  margin-top: 6px;
`
